import { useRef, useEffect } from 'react';
import '../useSSRLayoutEffect/bb39a440cfd2e66a91ef7db163af56b35e50f0e0f31c4c0e717387eb80740f64.cfe-internal.js';
import useSSRLayoutEffect from '../useSSRLayoutEffect/1b5a8c3b5463c14b01e195c9e403e1d1bbb3a66e0ef365e78fe012b249d635d1.cfe-internal.js';

var useDidUpdateBase = function useDidUpdateBase(useEffectFunction, func, deps) {
  var isFirstRenderRef = useRef(true);
  useEffectFunction(function () {
    if (isFirstRenderRef.current) {
      isFirstRenderRef.current = false;
      return undefined;
    }
    return func();
  }, deps);
};

/**
 * Wrapper around useEffect that runs on dependency updates only, not on initial render.
 * @param func - The effect function to run when dependencies have been updated.
 * @param deps - The list of dependencies to watch for changes.
 */
var useDidUpdate = function useDidUpdate(func, deps) {
  return useDidUpdateBase(useEffect, func, deps);
};

/**
 * Wrapper around useSSRLayoutEffect that runs on dependency updates only, not on initial render.
 * @param func - The effect function to run when dependencies have been updated.
 * @param deps - The list of dependencies to watch for changes.
 */
var useEnhancedDidUpdate = function useEnhancedDidUpdate(func, deps) {
  return useDidUpdateBase(useSSRLayoutEffect, func, deps);
};

export { useDidUpdate, useEnhancedDidUpdate };
